import { render, staticRenderFns } from "./rangeslider.vue?vue&type=template&id=1b58797f&"
import script from "./rangeslider.vue?vue&type=script&lang=js&"
export * from "./rangeslider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports